<template>
  <div class="drawElectronicSeal">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialog.show"
      :width="width"
      center
      @close="handclose"
    >
      <div class="center">
        <el-tabs type='border-card' @tab-click='tabClick'>
          <el-tab-pane :label='tabLabel[0]'>
            <imageRecognition
              :canvasUrl='canvasUrl'
              :label-position='labelPosition'
              @updateCanvasUrl="updateCanvasUrl"
            />
          </el-tab-pane>
          <el-tab-pane :label='tabLabel[1]'>
            <drawSeal
              :canvasUrl='canvasUrl'
              :corporateName="corporateName"
              :isEdit="isEdit"
              :label-position='labelPosition'
              :sealName="sealName"
              :sealShape="sealShape"
              :sealType="sealType"
              @submitForm="submitForm"
              @updateCanvasUrl="updateCanvasUrl"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer">
				<el-button @click="cancelFn">取 消</el-button>
				<el-button :disabled="!canvasUrl" type="primary" @click="submitFn">确 定</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
let that
import drawSeal from './drawSeal.vue'
import imageRecognition from './imageRecognition.vue'

export default {
  components: {
    drawSeal,
    imageRecognition
  },
  name: 'drawElectronicSeal',
  props: {
    close: {
      type: Function
    },
    confirm: {
      type: Function
    },
    cancel: {
      type: Function
    },
    fail: {
      type: Function
    },
    width: {
      type: String,
      default: '90%'
    },
    corporateName: { // 组织名称
      type: String,
      default: ''
    },
    sealName: { // 印章名称
      type: String,
      default: ''
    },
    sealShape: { // 印章形状
      type: String,
      default: ''
    },
    sealType: { // 印章类型 （如：公章）
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '选择'
    },
    tabLabel: {
      type: Array,
      default: () => {
        return ['AI识别红章', '自定义绘制']
      }
    },
    labelPosition: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      dialog: {
        show: false
      },
      canvasUrl: '',
      ruleForm: '',
    }
  },
  mounted() {
    that = this
  },
  methods: {

    submitFn() {
      this.dialog.show = false
      this.confirm({
        base64: this.canvasUrl,
        ...this.ruleForm
      })
    },
    show(data) {

      if (this.corporateName && this.sealName && this.sealShape) {
        if (['circular', 'ellipse', 'square'].includes(this.sealShape)) {
          this.dialog.show = true
        } else {
          console.error('印章类型有误');
        }
      } else {
        console.error('参数必填');
        this.fail && this.fail('参数必填')
      }

    },
    handclose() {
      this.close()
    },
    cancelFn() {
      this.dialog.show = false
      this.cancel()
    },
    tabClick() {
      this.canvasUrl = ''
    },
    updateCanvasUrl(url) {
      this.canvasUrl = url
      this.ruleForm = ''
    },
    submitForm(data) {
      this.ruleForm = data
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form {
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/drawElectronicSeal/drawElectronicSeal.vue